import SaveFitWrapper from '@components/FitFinder/SavedFit/SavedFitWrapper'
import { UIState } from '@components/FitFinder/SavedFit/types'
import { Button } from '@components/ui/Button'
import styles from './styles.module.scss'
import { useRouter } from 'next/router'
import { analytics } from '@helpers/analytics'
import { FIT_UPDATE_EVENT } from '@components/FitFinder/SavedFit/SavedFitConfirmationModal'
import { Fit } from 'types/fit'
import { useFitFinderToggle } from '@components/FitFinder/hooks/useFitFinderToggle'
import ButtonMinimal from '@components/ui/Button/ButtonMinimal'
import { prefixLocale } from '@helpers/env'
import FormButtonGroup from '@components/ui/formElements/form/shared/FormButtonGroup'

export default function CustomerSavedFit({ savedFit }: { savedFit: Fit }) {
  const { openFitFinder } = useFitFinderToggle()
  const router = useRouter()
  const handleAfterSubmit = () => {
    analytics(FIT_UPDATE_EVENT, {
      action: 'Fit edited',
      category: 'Account'
    })
  }
  const handleEditFit = (setUIState: (uiState: UIState) => void) => {
    setUIState('edit')
  }

  return (
    <div className={styles.CustomerSavedFitModalContainer}>
      <SaveFitWrapper
        method="account_fit"
        noPadding={true}
        title=""
        description=""
        savedFit={savedFit}
        showImage={false}
        afterSubmit={handleAfterSubmit}
        showShopButtons={false}
      >
        {({ uiState, setUIState }) => {
          return (
            <>
              {uiState === 'read' && (
                <div className={styles.savedFitModalContainer__buttonWrapper}>
                  <FormButtonGroup
                    variant="secondary-inline"
                    primaryCta={
                      <Button
                        variant="secondary"
                        fullWidth="always"
                        onClick={() =>
                          router.push(
                            `${prefixLocale()}/collections/best-sellers`
                          )
                        }
                      >
                        Shop Best Sellers
                      </Button>
                    }
                    secondaryCta={
                      <Button
                        variant="primary"
                        fullWidth="always"
                        onClick={() => handleEditFit(setUIState)}
                      >
                        Edit
                      </Button>
                    }
                  >
                    <ButtonMinimal underlined={true} onClick={openFitFinder}>
                      Retake the Fit Finder
                    </ButtonMinimal>
                  </FormButtonGroup>
                </div>
              )}
            </>
          )
        }}
      </SaveFitWrapper>
    </div>
  )
}
